import type {
  IBlackbaudContactMapping,
  IBlackbaudContactMappingUpdate,
  TBlackbaudContactMappingKey,
} from './blackbaud_raisers_edge';
import { IntegrationContactMappingStore } from './integration_contact_mappings';

/** Observable contact mappings for one Raiser's Edge integration. */
export class BlackbaudRaisersEdgeContactMappingStore extends IntegrationContactMappingStore<
  IBlackbaudContactMapping,
  TBlackbaudContactMappingKey,
  IBlackbaudContactMappingUpdate
> {}
